import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';

import { ACTION_TYPES } from './types';

export type CheckTokenState = {
  loading: boolean;
  data: {
    success: boolean;
    partner_user_id: string;
    username: string;
    status: {
      code: string;
      message: string;
    };
  };
};

export type RegisterAccountState = {
  loading: boolean;
  data: {
    permanent_token: string;
    status: {
      code: string;
      message: string;
    };
  };
};

export type RegisterStatusState = {
  loading: boolean;
  data: {
    permanent_token?: string | null;
    status: {
      code: string;
      message: string;
    };
  };
};

export type RegisterAccountTxDataState = {
  bankCode: string;
  credentialsData: {
    username: string;
    password: string;
  };
  token: string;
  hasRegistered: boolean;
  checkToken: CheckTokenState;
  register: RegisterAccountState;
  status: RegisterStatusState;
  finishedPolling: boolean;
  hasCalledPolling: boolean;
  firstPollingTime: string;
};

const initialState: RegisterAccountTxDataState = {
  bankCode: '',
  credentialsData: {
    username: sessionStorage.getItem('txDataUsername') || '',
    password: sessionStorage.getItem('txDataPassword') || '',
  },
  token: '',
  hasRegistered: false,
  checkToken: {
    loading: false,
    data: {
      success: false,
      partner_user_id: '',
      username: '',
      status: {
        code: '',
        message: '',
      },
    },
  },
  register: {
    loading: false,
    data: {
      permanent_token: '',
      status: {
        code: '',
        message: '',
      },
    },
  },
  status: {
    loading: false,
    data: {
      permanent_token: '',
      status: {
        code: '',
        message: '',
      },
    },
  },
  firstPollingTime: '',
  hasCalledPolling: false,
  finishedPolling: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.FILL_BANK_CODE:
      return update(state, {
        bankCode: {
          $set: payload,
        },
      });

    case ACTION_TYPES.FILL_TOKEN:
      return update(state, {
        token: {
          $set: payload,
        },
      });

    case ACTION_TYPES.HAS_REGISTERED:
      return update(state, {
        hasRegistered: {
          $set: true,
        },
      });

    case ACTION_TYPES.CHECK_TOKEN_REQUEST:
      return update(state, {
        checkToken: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.CHECK_TOKEN_REQUEST_SUCCESS:
      return update(state, {
        checkToken: {
          $merge: {
            data: payload,
            loading: false,
          },
        },
      });

    case ACTION_TYPES.CHECK_TOKEN_REQUEST_FAILED:
      return update(state, {
        checkToken: {
          $merge: {
            loading: false,
          },
        },
      });

    case ACTION_TYPES.REGISTER_ACCOUNT_REQUEST:
      sessionStorage.removeItem('txDataUsername');
      sessionStorage.removeItem('txDataPassword');
      return update(state, {
        register: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.REGISTER_ACCOUNT_REQUEST_SUCCESS:
      return update(state, {
        register: {
          $merge: {
            data: payload,
            loading: false,
          },
        },
      });

    case ACTION_TYPES.REGISTER_ACCOUNT_REQUEST_FAILED:
      return update(state, {
        register: {
          $merge: {
            loading: false,
          },
        },
      });

    case ACTION_TYPES.REGISTER_STATUS_REQUEST:
      return update(state, {
        status: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.REGISTER_STATUS_REQUEST_SUCCESS:
      return update(state, {
        status: {
          $merge: {
            data: payload,
            loading: false,
          },
        },
      });

    case ACTION_TYPES.REGISTER_STATUS_REQUEST_FAILED:
      return update(state, {
        status: {
          loading: {
            $set: false,
          },
        },
      });

    case ACTION_TYPES.FILL_BANK_CREDENTIALS:
      sessionStorage.setItem('txDataUsername', payload.username);
      sessionStorage.setItem('txDataPassword', payload.password);
      return update(state, {
        credentialsData: {
          $set: payload,
        },
      });

    case ACTION_TYPES.FINISHED_POLLING:
      return update(state, {
        finishedPolling: {
          $set: true,
        },
      });

    case ACTION_TYPES.SET_HAS_CALLED_POLLING:
      return update(state, {
        hasCalledPolling: {
          $set: true,
        },
      });

    case ACTION_TYPES.SET_FIRST_POLLING_TIME:
      return update(state, {
        firstPollingTime: {
          $set: payload,
        },
      });

    default:
      return state;
  }
};
